import { createRootRoute, Outlet, useLocation } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';
import { Navigation } from '../components/Navigation';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  const location = useLocation();
  // Remove CRT effects from /app/* routes for clean professional dashboard
  const isAppRoute = location.pathname.startsWith('/app/');
  const isDocsRoute = location.pathname.startsWith('/docs');
  const isIndexRoute = location.pathname === '/';
  const crtClasses = (isAppRoute || isDocsRoute) ? '' : 'scan-lines crt-curvature crt-flicker';
  const overflowClasses = isIndexRoute ? 'overflow-hidden index-route-container' : '';
  
  return (
    <>
      <div className={`h-screen ${overflowClasses} ${crtClasses} flex flex-col`}>
        <Navigation />
        <main className={`flex-1 ${isIndexRoute ? 'overflow-hidden' : 'overflow-y-auto'}`}>
          <Outlet />
        </main>
      </div>
      {process.env.NODE_ENV === 'development' && <TanStackRouterDevtools />}
    </>
  );
}